export default __webpack_public_path__ + "static/media/093-up-arrow-5.b451645f.png";